import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonRouterOutlet,
  useIonToast,
} from "@ionic/react";
import {
  Redirect,
  Route,
  useHistory,
  useLocation,
  useParams,
} from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import AppUserWelcomePage from "./AppUserWelcomePage";
import PLNPlusWelcomePage from "./PLNPlusWelcomePage";
import PLNPlusMemberInformationPage from "./PLNPlusMemberInformationPage";
import PLNPlusMemberGoalsPage from "./PLNPlusMemberGoalsPage";
import ConsultationSchedulerPage from "./ConsultationSchedulerPage";
import PLNPlusReferralPage from "./PLNPlusReferralPage";
import NotificationsPage from "./NotificationsPage";
import InstagramFollowPage from "./InstagramFollowPage";
import PLNPlusPaymentMethodPage from "./PLNPlusPaymentMethodPage";
import AppUserPLNPerksEnrollmentPage from "./AppUserPLNPerksEnrollmentPage";
import AppUserLocationPage from "./AppUserLocationPage";
import AppUserPLNPlusUpsellPage from "./AppUserPLNPlusUpsellPage";
import ProgressTrackingIntroPage from "./ProgressTrackingIntroPage";

const OnboardingWrapper: React.FC<{
  nativeMode?: boolean;
}> = ({ nativeMode = false }) => {
  const history = useHistory();
  const [present] = useIonToast();
  const [completing, setCompleting] = useState(false);
  const [hasConsult, setHasConsult] = useState(false);
  const [canHaveConsult, setCanHaveConsult] = useState(false);

  const pageRef = useRef();

  const params = useParams<{
    onboarding: string;
    step: string;
  }>();

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");
    loadConsultations();
  }, []);

  useEffect(() => {
    loadConsultations();

    loadUser(true).then((user: any) => {
      if (!user) {
        return;
      }

      if (
        !user?.onboardingCompleted &&
        !window?.location?.pathname?.includes("/onboarding")
      ) {
        let onboarding = user?.customer
          ? "onboarding_plnplus_postsignup"
          : "onboarding_appuser";

        setTimeout(() => {
          history.push(`/onboarding/${onboarding}/welcome`);
        }, 1);

        return;
      } else if (user?.onboardingCompleted) {
        setTimeout(() => {
          history.push(`/manage/home`);

          setTimeout(() => {
            window.location.reload();
          }, 30);
        }, 1);
      }
    });
  }, []);

  const loadConsultations = async () => {
    let user = await StorageUtils.get("user_customer");

    if (!user) {
      history.push("/login");

      return;
    }

    API.getAppointments(1, 500, {
      appointmentType: "nc-consult",
      status: { $in: ["COMPLETED", "CONFIRMED"] },
      startsAt: {
        $gte: { $date: moment().subtract(60, "days").toISOString() },
      },
    }).then(
      (data: any) => {
        setHasConsult(data?.data?.data?.appointments?.length > 0);
      },
      () => {},
    );
  };

  const loadUser = async (force = false) => {
    return new Promise(async (resolve: any) => {
      const user = await StorageUtils.get("user_customer");

      if (!force && user) {
        resolve(user);

        return;
      }

      API.getAccount().then(
        async (data: any) => {
          //console.log("ACCOUNT", data?.data?.data);

          const {
            user,
            customer,
            store,
            homeFeed,
            billingError,
            referralProgram,
          } = data?.data?.data;

          console.log(data?.data?.data);

          await StorageUtils.set("user_customer", user);
          await StorageUtils.set("user_homeFeed", homeFeed);
          await StorageUtils.set("user_store", store);
          await StorageUtils.set("user_referralProgram", referralProgram);

          if (
            DateUtils.storeCanScheduleConsultations(store) &&
            DateUtils.storeHasOpenHours(store)
          ) {
            setCanHaveConsult(true);
          } else {
            setCanHaveConsult(false);
          }

          console.log("LOAD USER");

          resolve(user);
        },
        (e) => {
          console.error(e);

          resolve(null);
        },
      );
    });
  };

  /**
   * Completes the onboarding.
   */
  const completeOnboarding = () => {
    setCompleting(true);
    API.setAppUserParameter("onboardingCompleted", true)
      .then(
        (res: any) => {
          loadUser(true).then(
            () => {
              present({
                message:
                  "Your account setup is complete. Welcome to the PLN app!",
                duration: 1500,
                position: "bottom",
                icon: checkmarkCircle,
                color: "success",
                layout: "baseline",
                mode: "ios",
                buttons: [
                  {
                    text: "OK",
                    role: "cancel",
                  },
                ],
              });

              // TODO: set complete here
              history.push(`/manage/home`);
              setCompleting(false);
            },
            () => {},
          );
        },
        (e) => {
          console.error(e);
        },
      )
      .finally(() => {
        setCompleting(false);
      });
  };

  return (
    <>
      {completing && (
        <IonLoading
          isOpen={completing}
          message="Completing onboarding..."
          backdropDismiss={false}
        />
      )}
      <IonRouterOutlet>
        <Route path="/onboarding/onboarding_plnplus_postsignup/welcome">
          <PLNPlusWelcomePage
            next={() => {
              history.push(
                `/onboarding/onboarding_plnplus_postsignup/information`,
              );
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={false}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/information">
          <PLNPlusMemberInformationPage
            next={async () => {
              const user = await StorageUtils.get("user_customer");

              // Send to update payment method
              if (!user?.customer?.paymentMethod?.stripePaymentMethod) {
                history.push(
                  `/onboarding/onboarding_plnplus_postsignup/payment`,
                );
              } else if (Capacitor.isNativePlatform()) {
                // Send to notifications
                history.push(
                  `/onboarding/onboarding_plnplus_postsignup/notifications`,
                );
              } else {
                // Send to goals
                history.push(`/onboarding/onboarding_plnplus_postsignup/goals`);
              }
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/payment">
          <PLNPlusPaymentMethodPage
            next={async () => {
              const user = await StorageUtils.get("user_customer");

              // Send to notifications
              if (Capacitor.isNativePlatform()) {
                history.push(
                  `/onboarding/onboarding_plnplus_postsignup/notifications`,
                );
              } else {
                // Send to goals
                history.push(`/onboarding/onboarding_plnplus_postsignup/goals`);
              }
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/notifications">
          <NotificationsPage
            next={() => {
              history.push(`/onboarding/onboarding_plnplus_postsignup/goals`);
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/goals">
          <PLNPlusMemberGoalsPage
            next={() => {
              if (!hasConsult && canHaveConsult) {
                history.push(`/onboarding/onboarding_plnplus_postsignup/5`);
              } else {
                history.push(`/onboarding/onboarding_plnplus_postsignup/6`);
              }
              /*history.push(
                `/onboarding/onboarding_plnplus_postsignup/progress-tracking`,
              );*/
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/progress-tracking">
          <ProgressTrackingIntroPage
            next={() => {
              if (!hasConsult && canHaveConsult) {
                history.push(`/onboarding/onboarding_plnplus_postsignup/5`);
              } else {
                history.push(`/onboarding/onboarding_plnplus_postsignup/6`);
              }
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/5">
          <ConsultationSchedulerPage
            pageName="Schedule"
            next={() => {
              history.push(`/onboarding/onboarding_plnplus_postsignup/6`);
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
            title="Schedule Your First Coach Consultation"
            subtitle="Schedule your first one-on-one session to set clear goals, review your InBody scan, and tailor your new PLN+ plan for success."
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/6">
          <PLNPlusReferralPage
            next={() => {
              history.push(`/onboarding/onboarding_plnplus_postsignup/7`);
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_plnplus_postsignup/7">
          <InstagramFollowPage
            next={() => {
              completeOnboarding();
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/welcome">
          <AppUserWelcomePage
            next={() => {
              history.push(`/onboarding/onboarding_appuser/information`);
            }}
            previous={() => {}}
            hasNext={true}
            hasPrevious={false}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/information">
          <AppUserPLNPerksEnrollmentPage
            next={() => {
              if (Capacitor.isNativePlatform()) {
                history.push(`/onboarding/onboarding_appuser/notifications`);
              } else {
                history.push(`/onboarding/onboarding_appuser/location`);
              }
            }}
            previous={() => {
              history.goBack();
            }}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/location">
          <AppUserLocationPage
            next={async () => {
              let user = await StorageUtils.get("user_customer");

              if (user?.storeID) {
                history.push(`/onboarding/onboarding_appuser/plnplus`);
              } else {
                history.push(`/onboarding/onboarding_appuser/instagram`);
              }
            }}
            previous={() => {
              history.goBack();
            }}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/plnplus">
          <AppUserPLNPlusUpsellPage
            next={() => {
              //history.push(`/onboarding/onboarding_appuser/progress-tracking`);
              history.push(`/onboarding/onboarding_appuser/consultation`);
            }}
            previous={() => {
              history.goBack();
            }}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/progress-tracking">
          <ProgressTrackingIntroPage
            next={() => {
              history.push(`/onboarding/onboarding_appuser/consultation`);
            }}
            previous={() => {
              history.goBack();
            }}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/consultation">
          <ConsultationSchedulerPage
            allowSkip={true}
            next={() => {
              history.push(`/onboarding/onboarding_appuser/instagram`);
            }}
            previous={() => {
              history.goBack();
            }}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/notifications">
          <NotificationsPage
            next={() => {
              history.push(`/onboarding/onboarding_appuser/location`);
            }}
            previous={() => {
              history.goBack();
            }}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
        <Route path="/onboarding/onboarding_appuser/instagram">
          <InstagramFollowPage
            next={() => {
              completeOnboarding();
            }}
            previous={() => {
              history.goBack();
            }}
            hasNext={true}
            hasPrevious={true}
            step={{}}
            nativeMode={nativeMode}
          />
        </Route>
      </IonRouterOutlet>
    </>
  );
};

export default OnboardingWrapper;
